import React, { Fragment } from "react";
import { PDFViewer } from "@react-pdf/renderer";
import { Link } from "react-router-dom";

import OnboardingMain from "./OnboardingMain";
import store from "../../../store";

const OnboardingForm = () => {
  return (
    <Fragment>
      <Link className="py-5 my-5 ml-3 text-decoration-none back-link" to="/CandidateList">
        Back to Candidates List
      </Link>
      <PDFViewer className="mt-3" width="100%" height="1000">
        <OnboardingMain store={store} />
      </PDFViewer>
    </Fragment>
  );
};

export default OnboardingForm;
